export const getAuditListColumns = (isAuditorView) => {
  if (isAuditorView) {
    return [
      { label: "Audit Name", field: "audit_name", width: "18%", align: "left" },
      { label: "Organization", field: "customer_name", width: "14%", align: "left" },
      { label: "Framework", field: "framework_name", width: "13%", align: "left" },
      { label: "Audit Type", field: "audit_type", width: "11%", align: "left" },
      { label: "Audit Period", field: "evidence_period", width: "22%", align: "left" },
      { label: "Total Controls", field: "total_controls", width: "13%", align: "left" },
      { label: "", field: "action", width: "5%", align: "left" },
    ];
  }
  
  return [
    { label: "Audit Name", field: "audit_name", width: "22%", align: "left" },
    { label: "Framework", field: "framework_name", width: "13%", align: "left" },
    { label: "Audit Type", field: "audit_type", width: "11%", align: "left" },
    { label: "Auditor", field: "auditor_name", width: "14%", align: "left" },
    { label: "Audit Period", field: "evidence_period", width: "20%", align: "left" },
    { label: "Total Controls", field: "total_controls", width: "13%", align: "left" },
    { label: "", field: "action", width: "10%", align: "left" },
  ];
};
